<div class="body widget-list-body">

    <div class="widget-header">

        <span class="headline">Kunden</span>

        <button mat-icon-button *ngIf="userFilterIdentifier > 0" [matMenuTriggerFor]="sortMenu" matTooltip="Sortierung anpassen">
            <mat-icon>sort_by_alpha</mat-icon>
        </button>

        <button mat-icon-button (click)="showSearchInput = !showSearchInput" [matTooltip]="showSearchInput? 'Suchfeld ausblenden' : 'Suchfeld einblenden'">
            <mat-icon>{{showSearchInput? 'search_off': 'search'}}</mat-icon>
        </button>

        <button mat-icon-button (click)="setInitialDefaultView()" color="warn" matTooltip="Startsicht anzeigen" [disabled]="currentView === CustomerWidgetDefaultViews[0]">
            <mat-icon>clear</mat-icon>
        </button>

    </div>

    <mat-form-field *ngIf="showSearchInput" @show class="widget-search-input">
        <mat-label>Suchbegriff</mat-label>
        <input matInput [(ngModel)]="searchFilter" (keyup.enter)="sendSearch()" appAutofocus />
        <button matSuffix mat-icon-button (click)="sendSearch()">
            <mat-icon>search</mat-icon>
        </button>
    </mat-form-field>

    <div class="widget-header-bar">

        <div *ngIf="viewTitle && !showSearchInput" class="widget-default-view-chooser" [matMenuTriggerFor]="selectDefaultViewMenu">
        
            <span class="text">
                {{viewTitle}}
            </span>
    
        </div>
        <div class="spacer"></div>
        <div class="counter">
            <span>{{entries && entries.length? entries.length: 0}}</span> von <span>{{totalItems}}</span>
        </div>

    </div>

    <div class="widget-list-content">

        <div class="entry" [ngClass]="{ 'danger': !customer.customeractive }" *ngFor="let customer of entries" (click)="editCustomer(customer)">
            <app-customer-preview [customer]="customer"></app-customer-preview>
        </div>

        <div *ngIf="entries && entries.length && entries.length < totalItems" class="load-more-wrapper" (click)="loadMore()">
            <div class="load-more">Mehr laden</div>
        </div>

    </div>
</div>

<mat-menu #selectDefaultViewMenu="matMenu">
    <button mat-menu-item *ngFor="let view of CustomerWidgetDefaultViews" class="dropdown-item" (click)="setDefaultView(view)">
        <mat-icon class="icon">{{view.icon}}</mat-icon>
        <span>{{view.title}}</span>
    </button>
</mat-menu>

<mat-menu #sortMenu="matMenu">
    <button mat-menu-item *ngFor="let criteria of currentFilterType.criteria" class="dropdown-item" (click)="setFilter(criteria)">
        <mat-icon class="dropdown-icon" [ngClass]="criteria.value == sortAttribute? 'active': 'inactive'">done</mat-icon>
        <span>{{criteria.title}}</span>
        <ng-container *ngIf="criteria.value == sortAttribute">
            <mat-icon *ngIf="!sortDsc">arrow_drop_up</mat-icon>
            <mat-icon *ngIf="sortDsc">arrow_drop_down</mat-icon>
        </ng-container>
    </button>
</mat-menu>
